import { IconProps } from './icons-props';

function TimerIcon({ className, width = 24, height = 24 }: IconProps) {
    return (
        <svg
            fill='none'
            className={className}
            width={width}
            height={height}
            viewBox='0 0 41 42'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M26.0352 39.8125H14.9652C11.7365 39.8125 9.37898 38.43 8.47356 36.05C7.53398 33.565 8.40523 30.485 10.6602 28.4025L18.5869 21L10.6602 13.5975C8.40523 11.515 7.53398 8.435 8.47356 5.95C9.37898 3.5525 11.7365 2.1875 14.9652 2.1875H26.0352C29.264 2.1875 31.6215 3.57 32.5269 5.95C33.4665 8.435 32.5952 11.515 30.3402 13.5975L22.4136 21L30.3573 28.4025C32.5952 30.485 33.4836 33.565 32.544 36.05C31.6215 38.43 29.264 39.8125 26.0352 39.8125ZM20.5002 22.7675L12.3856 30.3275C10.9506 31.675 10.3186 33.635 10.8652 35.0875C11.3777 36.435 12.8298 37.1875 14.9652 37.1875H26.0352C28.1706 37.1875 29.6227 36.4525 30.1352 35.0875C30.6819 33.635 30.0669 31.675 28.6148 30.3275L20.5002 22.7675ZM14.9652 4.8125C12.8298 4.8125 11.3777 5.5475 10.8652 6.9125C10.3186 8.365 10.9336 10.325 12.3856 11.6725L20.5002 19.2325L28.6148 11.6725C30.0498 10.325 30.6819 8.365 30.1352 6.9125C29.6227 5.565 28.1706 4.8125 26.0352 4.8125H14.9652Z'
                fill='currentColor'
            />
        </svg>
    );
}

export default TimerIcon;

